import { IconProps } from "ztypes/icon-props";

const IconRocket2: React.FunctionComponent<IconProps> = (props) => {
  return (
    <svg
      className={props.className}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Launch Rocket 3">
        <path
          id="Vector"
          d="M15.1405 18.6712L9.32959 12.8603L16.7935 5.39639C17.7695 4.41992 18.9983 3.7346 20.342 3.41727C21.6857 3.09993 23.0912 3.16311 24.4011 3.59972C24.8377 4.90953 24.9009 6.31507 24.5835 7.65877C24.2662 9.00247 23.5809 10.2312 22.6044 11.2073L15.1405 18.6712Z"
          stroke="#0068FF"
          strokeWidth="1.54"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_2"
          d="M19.4999 9.60015C20.1074 9.60015 20.5999 9.10766 20.5999 8.50015C20.5999 7.89263 20.1074 7.40015 19.4999 7.40015C18.8924 7.40015 18.3999 7.89263 18.3999 8.50015C18.3999 9.10766 18.8924 9.60015 19.4999 9.60015Z"
          fill="#0068FF"
        />
        <path
          id="Vector_3"
          d="M11.5046 19.4L8.59912 16.4946L10.057 13.5891L14.4101 17.9422L11.5046 19.4Z"
          stroke="#0068FF"
          strokeWidth="1.54"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_4"
          d="M18.0425 15.7708C18.4238 16.1521 18.7263 16.6048 18.9327 17.1031C19.1391 17.6013 19.2453 18.1353 19.2453 18.6746C19.2453 19.2139 19.1391 19.7479 18.9327 20.2462C18.7263 20.7444 18.4238 21.1971 18.0425 21.5785L15.8646 23.7563C15.0944 22.9862 14.6618 21.9416 14.6618 20.8525C14.6618 19.7633 15.0944 18.7188 15.8646 17.9486L18.0425 15.7708Z"
          stroke="#0068FF"
          strokeWidth="1.54"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_5"
          d="M4.248 12.1452L6.42589 9.96733C7.19604 9.19718 8.24059 8.76452 9.32974 8.76452C10.4189 8.76452 11.4634 9.19718 12.2336 9.96733L10.0557 12.1452C9.28556 12.9154 8.24101 13.348 7.15186 13.348C6.0627 13.348 5.01815 12.9154 4.248 12.1452Z"
          stroke="#0068FF"
          strokeWidth="1.54"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_6"
          d="M5.50782 18.3837C5.7755 18.0746 6.10204 17.8219 6.4684 17.6404C6.83475 17.4588 7.23359 17.352 7.64165 17.3262C8.04971 17.3004 8.45883 17.3561 8.84513 17.4901C9.23144 17.624 9.58721 17.8336 9.89169 18.1065C10.1646 18.4109 10.3741 18.7667 10.5081 19.153C10.642 19.5393 10.6977 19.9484 10.6719 20.3565C10.6461 20.7646 10.5393 21.1634 10.3578 21.5298C10.1762 21.8961 9.92356 22.2226 9.61449 22.4903C7.27369 24.8311 3.21835 24.7798 3.21835 24.7798C3.21835 24.7798 3.16702 20.7245 5.50782 18.3837Z"
          stroke="#0068FF"
          strokeWidth="1.54"
          strokeMiterlimit="10"
        />
      </g>
    </svg>
  );
};

export default IconRocket2;
